import { render, staticRenderFns } from "./ShareDraftModal.vue?vue&type=template&id=c0604244&scoped=true"
import script from "./ShareDraftModal.vue?vue&type=script&lang=js"
export * from "./ShareDraftModal.vue?vue&type=script&lang=js"
import style0 from "./ShareDraftModal.vue?vue&type=style&index=0&id=c0604244&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0604244",
  null
  
)

export default component.exports